/**
 * Componente principal de configuración de soporte con tabs verticales
 * 
 * Referencia: sistema-tickets-frontend-COMPLETO.md Sección 5.1
 */

import React, { useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Tabs,
  Tab,
  Divider
} from '@mui/material';
import CategoryIcon from '@mui/icons-material/Category';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
// import DescriptionIcon from '@mui/icons-material/Description';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';

// Importar componentes de gestión
import GestionCategoriasComponent from './admin/GestionCategoriasComponent';
import GestionPrioridadesComponent from './admin/GestionPrioridadesComponent';
// import GestionPlantillasComponent from './admin/GestionPlantillasComponent';
// import GestionAgentesComponent from './admin/GestionAgentesComponent';
import ConfiguracionGeneralComponent from './admin/ConfiguracionGeneralComponent';

// Definir tabs disponibles
const TABS = [
  { 
    id: 'categorias', 
    label: 'Categorías', 
    icon: <CategoryIcon />, 
    component: GestionCategoriasComponent 
  },
  { 
    id: 'prioridades', 
    label: 'Prioridades', 
    icon: <PriorityHighIcon />, 
    component: GestionPrioridadesComponent 
  },
  // { 
  //   id: 'plantillas', 
  //   label: 'Plantillas', 
  //   icon: <DescriptionIcon />, 
  //   component: GestionPlantillasComponent 
  // },
  // { 
  //   id: 'agentes', 
  //   label: 'Agentes', 
  //   icon: <PeopleIcon />, 
  //   component: GestionAgentesComponent 
  // },
  { 
    id: 'general', 
    label: 'General', 
    icon: <SettingsIcon />, 
    component: ConfiguracionGeneralComponent 
  }
];

const ConfiguracionSoporteComponent = () => {
  const [tabActiva, setTabActiva] = useState('categorias');
  
  const handleTabChange = (event, newValue) => {
    setTabActiva(newValue);
  };
  
  const TabComponent = TABS.find(t => t.id === tabActiva)?.component;
  
  return (
    <Box sx={{ p: 3 , caretColor: 'transparent'}}>
      <Typography variant="h4" gutterBottom>
        Configuración de Soporte
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Administra las categorías, prioridades, agentes y configuración general del sistema de soporte
      </Typography>
      
      <Divider sx={{ my: 3 }} />
      
      <Box sx={{ display: 'flex', gap: 3 }}>
        {/* Tabs Verticales */}
        <Paper elevation={2} sx={{ width: 250, flexShrink: 0 }}>
          <Tabs
            orientation="vertical"
            value={tabActiva}
            onChange={handleTabChange}
            sx={{ 
              borderRight: 1, 
              borderColor: 'divider',
              '& .MuiTab-root': {
                minHeight: 64,
                textAlign: 'left',
                justifyContent: 'flex-start',
                paddingLeft: 3
              }
            }}
          >
            {TABS.map(tab => (
              <Tab
                key={tab.id}
                label={tab.label}
                value={tab.id}
                icon={tab.icon}
                iconPosition="start"
                sx={{ 
                  justifyContent: 'flex-start', 
                  alignItems: 'center',
                  textTransform: 'none',
                  fontSize: '0.95rem'
                }}
              />
            ))}
          </Tabs>
        </Paper>
        
        {/* Contenido */}
        <Box flex={1} sx={{ minWidth: 0 }}>
          {TabComponent && <TabComponent />}
        </Box>
      </Box>
    </Box>
  );
};

export default ConfiguracionSoporteComponent;

